import graphql__61f8d43c9ede17d6a809 from "./__generated__/StoreLocationVisitMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__61f8d43c9ede17d6a809;

function storeLocationVisit(pathname, onCompleted) {
  return commitMutation(appRelayEnvironment, {
    mutation,
    variables: { pathname },
    onCompleted,
    onError: error => console.error(error)
  });
}

export { storeLocationVisit };
